const doc = [({"ja":({"adminLabelHotelFilter":({"type":"タイプ", "filterName":"フィルタ名", "masterFilterId":"フィルタ項目"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;